import React from "react";
import { Helmet } from "react-helmet-async";

const Bokaro = () => {
  return (
    <>
      <Helmet>
        <title>Fly Ash Bricks, Blocks & Paver Blocks in Bokaro | Anil Flyash Bricks</title>
        <meta
          name="description"
          content="Anil Flyash Bricks – the leading manufacturer and dealer of fly ash bricks, blocks, and paver blocks in Bokaro. Get durable, eco-friendly, and affordable construction materials across Jharkhand."
        />
        <meta
          name="keywords"
          content="bricks in Bokaro, flyash bricks in Bokaro, fly ash blocks in Bokaro, flyash bricks dealer in Bokaro, flyash bricks manufacturer in Bokaro, paver blocks in Bokaro, paver manufacturer Bokaro, construction materials Bokaro, Anil Flyash Bricks Bokaro"
        />
        <link rel="canonical" href="https://anilbricks.com/flyash-bricks-in-bokaro" />
      </Helmet>

      <div className="py-16 px-6 md:px-20 bg-gray-50 text-gray-800">
        <h1 className="text-3xl font-bold mb-6 text-green-700 text-center">
          Fly Ash Bricks, Blocks & Paver Blocks in Bokaro
        </h1>

        <p className="text-lg leading-relaxed mb-4">
          Welcome to <strong>Anil Flyash Bricks</strong> — Bokaro’s trusted source for
          <strong> fly ash bricks, fly ash blocks, and decorative paver blocks</strong>.
          We supply construction materials that combine strength, precision, and sustainability,
          helping you build structures that last for generations.
        </p>

        <p className="text-lg leading-relaxed mb-4">
          Our <strong>fly ash bricks</strong> are manufactured using advanced machinery, ensuring 
          uniform size, smooth finish, and high compressive strength. These bricks are 
          <em>eco-friendly</em>, cost-effective, and perfect for homes, commercial complexes, and industrial buildings.
        </p>

        <p className="text-lg leading-relaxed mb-4">
          Alongside bricks, we produce premium <strong>paver blocks</strong> in various designs and colors,
          ideal for pathways, driveways, gardens, and parking areas. Our durable <strong>fly ash blocks</strong> 
          are a preferred choice for modern construction due to their load-bearing capacity and sustainability.
        </p>

        <p className="text-lg leading-relaxed mb-4">
          Whether you’re searching for <em>“bricks in Bokaro”</em>, 
          <em>“paver block manufacturer near me”</em>, or 
          <em>“fly ash bricks dealer in Bokaro”</em>, 
          <strong>Anil Flyash Bricks</strong> delivers the quality and service you can trust.
          We supply across <strong>Bokaro Steel City, Chas, Gomia, and Petarwar</strong> with prompt delivery.
        </p>

        <p className="text-lg leading-relaxed mb-6">
          Choose us for superior quality, on-time delivery, and environmentally responsible
          construction materials. Contact us for bulk orders, custom brick sizes, or franchise opportunities in Bokaro.
        </p>

        <a
          href="/"
          className="bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-full font-semibold shadow-md transition"
        >
          Visit Main Website
        </a>
      </div>
    </>
  );
};

export default Bokaro;
